import { render } from "./exchange.vue?vue&type=template&id=0a805082&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=0a805082&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a805082"]])

export default __exports__